export default function HomePage() {
  return (
    <div className="flex flex-col items-center justify-center h-full bg-gray-300">
      <img src="/home-image.jpg" alt="프리온보딩 사전과제" />
    </div>
  );
}
